import React from 'react'

import facadeInit, { iFacadeApi, iFacadeConfig } from '../../facade'
import { ArqContext } from '../arq-context/arq-context'

export interface iArchitectureProviderProps {
  config: iFacadeConfig
  Idle: React.ElementType
  Error: React.ElementType
  LazySuccessComponent: React.LazyExoticComponent<any>
  customInitializer?: <T extends { [key: string]: any }>(
    api: iFacadeApi,
  ) => Promise<T | any>
}

export type iArchitectureProvider =
  React.FunctionComponent<iArchitectureProviderProps>

const ArchitectureProvider: iArchitectureProvider = ({
  config,
  Idle,
  Error,
  LazySuccessComponent,
  customInitializer,
}) => {
  const [status, setStatus] = React.useState('idle')
  const [apiState, setApiState] = React.useState<iFacadeApi | null>(
    null,
  )
  const initFacade = async (): Promise<void> => {
    try {
      let api = await facadeInit(config)
      if (customInitializer !== undefined)
        api = { ...api, ...(await customInitializer(api)) }

      setApiState(api)
      setStatus('success')
    } catch (error) {
      console.error(error)
      setStatus('error')
    }
  }

  React.useEffect(() => {
    initFacade()
  }, [])

  if (status === 'success')
    return (
      <ArqContext.Provider value={apiState}>
        <React.Suspense fallback={<Idle />}>
          <LazySuccessComponent />
        </React.Suspense>
      </ArqContext.Provider>
    )

  if (status === 'error') return <Error />

  return <Idle />
}

export { ArchitectureProvider }
